// Anken pre-flight withdrawal eligibility check, used to disable the withdraw button on the
// client. Client-side UX gate only - the backend independently re-checks the same condition
// server-side before actually withdrawing, so this stays advisory, not authoritative.
//
// Only 業務完了 counts as withdrawal-safe; cancelled statuses (受注取消/商品変更取消) still
// block, same as any in-progress status.
export function isWithdrawable (ankenList) {
  return !ankenList.find(anken => anken.status !== '業務完了')
}
